import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import routes from '@configs/routes.json';
import { IDownloadResultsPackageForUI } from '@models';

import DownloadResultsTable from './DownloadResultsTable';
import './DownloadResultsTableContainer.scss';

interface DownloadResultsTableContainerProps {
  uiSummaryList: IDownloadResultsPackageForUI[];
}

const DownloadResultsTableContainer: React.FC<DownloadResultsTableContainerProps> =
  ({ uiSummaryList }) => {
    const { t } = useTranslation();
    return (
      <Row className='summary-samples-table'>
        <Col>
          {uiSummaryList.map((data) => (
            <React.Fragment key={data.orderId}>
              <h6 className='mt-3 font-size-14 order-title'>
                <Link to={`${routes.app.orders}/${data.orderId}`}>
                  {t('downloadResultsPkg_summaryTable_orderTitle', {
                    orderNumber: data.orderId,
                    orderDescription: data.orderDescription,
                  })}
                </Link>
              </h6>
              <DownloadResultsTable list={data.summaries} />
            </React.Fragment>
          ))}
        </Col>
      </Row>
    );
  };

export default DownloadResultsTableContainer;
